<template>
    <div>
        <v-row class="mt-1">
            <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRetainedExpensesLease" 
                            label="Lease Expenses"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRetainedExpensesSoftware" 
                            label="Software Expenses"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRetainedExpensesOther" 
                            label="Other Expenses"
                            prepend-inner-icon="mdi-currency-usd">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>
             <v-col cols="12" sm="6" md="6">
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRetainedExpensesEmployeesLicensed" 
                            label="Licensed Employee Expenses"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateRetainedExpensesEmployeesTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model.lazy="dataRetainedExpensesEmployeesUnlicensed" 
                            label="Unlicensed Employee Expenses"
                            prepend-inner-icon="mdi-currency-usd"
                            @change="calculateRetainedExpensesEmployeesTotal">
                        </v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field 
                            v-model="dataRetainedExpensesEmployees" 
                            label="Employee Expenses"
                            prepend-inner-icon="mdi-currency-usd"
                            disabled
                            persistent-hint
                            hint="Calculation of Licensed & Unlicensed Employee Expenses">
                        </v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </div>
</template>


<script>
    import { 
        formatNumbers,
        scrubNumbers } from '../../helpers/utilities'
    
    export default {
        name: 'AnnualRetainedExpenses',
        props: [
            'editData'
        ],
        data: () => ({
            name: 'AnnualRetainedExpenses'
        }),
        
        mounted () {},
        
        computed: {
            dataRetainedExpensesLease: {
                get: function() {
                    return this.editData.retained_expenses_lease != null ? formatNumbers(scrubNumbers(this.editData.retained_expenses_lease)) : ''
                },
                set: function(val) {
                    this.swapNumbers('retained_expenses_lease', val);
                    return val;
                }
            },
            dataRetainedExpensesSoftware: {
                get: function() {
                    return this.editData.retained_expenses_software != null ? formatNumbers(scrubNumbers(this.editData.retained_expenses_software)) : ''
                },
                set: function(val) {
                    this.swapNumbers('retained_expenses_software', val);
                    return val
                }
            },
            dataRetainedExpensesOther: {
                get: function() {
                    return this.editData.retained_expenses_other != null ? formatNumbers(scrubNumbers(this.editData.retained_expenses_other)) : ''
                },
                set: function(val) {
                    this.swapNumbers('retained_expenses_other', val);
                    return val;
                }
            },
            dataRetainedExpensesEmployeesLicensed: {
                get: function() {
                    return this.editData.retained_expenses_employees_licensed != null ? formatNumbers(scrubNumbers(this.editData.retained_expenses_employees_licensed)) : ''
                },
                set: function(val) {
                    this.swapNumbers('retained_expenses_employees_licensed', val);
                    return val;
                }
            },
            dataRetainedExpensesEmployeesUnlicensed: {
                get: function() {
                    return this.editData.retained_expenses_employees_unlicensed != null ? formatNumbers(scrubNumbers(this.editData.retained_expenses_employees_unlicensed)) : ''
                },
                set: function(val) {
                    this.swapNumbers('retained_expenses_employees_unlicensed', val);
                    return val
                }
            },
            dataRetainedExpensesEmployees: {
                get: function() {
                    return this.editData.retained_expenses_employees != null ? formatNumbers(this.editData.retained_expenses_employees) : ''
                },
                set: function(val) {
                    this.calculateRetainedExpensesEmployeesTotal;
                }
            },
        },

        methods: {
            swapNumbers: function (field, val) {
                this.editData[field] = scrubNumbers(val);
            },

            calculateRetainedExpensesEmployeesTotal: function () {
                const calculated_val = Math.round( 
                    (parseInt(this.editData.retained_expenses_employees_licensed) || 0) + 
                    (parseInt(this.editData.retained_expenses_employees_unlicensed) || 0) 
                );
                this.dataRetainedExpensesEmployees = formatNumbers(calculated_val);
                this.editData.retained_expenses_employees = parseInt(calculated_val);
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/prospectus-sections/AnnualRetainedExpenses.vue